import { createTheme } from '@mui/material/styles'

import { primary, secondary } from '@/Theme/colors'
import { components } from '@/Theme/components'
import { typography } from '@/Theme/typography'

const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1920
    }
  },
  palette: {
    primary,
    secondary
  },
  typography,
  components
})

export default theme
